import * as React from "react";
import { StyleSheet, View } from "react-native";
import { Text, DefaultTheme } from "react-native-paper";
import { connect } from "react-redux";
import { actionCreators } from "../../test/action";
import routes from "../../routing/routes";
import {
  blackColor,
  whiteColor,
  editProfileColor,
  companySloganColor,
} from "../../common/colors";
import t from '../../translations';

// import { Avatar } from 'react-native-paper';
import Button from "../../common/Button";
import ListItem from "../../common/ListItem";
import StarRates from "../../common/StarRates";
import PageContainer from "../../common/PageContainer";
// import Language from "../Language";

const Settings = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const goToEditProfilePage = () =>
    props.navigation.navigate(routes.EditProfilePage);
  const logOut = () => props.navigation.navigate(routes.SignOut);

  return (
    <PageContainer
      {...props}
      isBackIcon={false}
      isSettingsIconSelected={true}
      noBackground={true}
    >
      <View style={styles.settingsContainer}>
        <Text style={styles.settings}>{t('settings_title')}</Text>
        <View style={styles.avatar}>
          {/* <Avatar.Text size={100} label="XD" color='cyan' /> */}
          <View style={styles.userNameAndEmailContainer}>
            <Text style={styles.userName}>{props?.user?.user.displayName}</Text>
            <Text style={styles.userEmail}>{props?.user?.user.email}</Text>
            <Text style={styles.editProfile} onPress={goToEditProfilePage}>
            {t('settings_title')}
            </Text>
          </View>
        </View>
        <View style={styles.clickToLogOut}>
          {/* <Language /> */}
          <Button onPress={logOut} value={t('settings_logOut')} />
        </View>
      </View>
      <ListItem {...props} />
      {/* <StarRates /> */}
      <View style={styles.loriiniTribes}>
        <Text style={styles.companySlogan}>@Loriini Tribes - 2021 - 2022</Text>
        <Text style={styles.companySlogan}>
        {t('settings_slogan')} {"<3"}
        </Text>
      </View>
    </PageContainer>
  );
};

const mapStateToProps = (state) => {
  const user = state.user;
  return { user };
};

export default connect(mapStateToProps, actionCreators)(Settings);

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
    backgroundColor: whiteColor,
  },
  container: {
    width: "100%",
    height: "100%",
  },
  settingsContainer: {
    paddingTop: 23,
    width: "100%",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  settings: {
    paddingLeft: 20,
    fontSize: 16,
    lineHeight: 26,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: blackColor,
    textTransform: "uppercase",
    alignSelf: "flex-start",
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
  },
  containerButtons: {
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
  },
  icons: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: 30,
    width: 380,
  },
  screenBackground: {
    width: "100%",
    height: "100%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
  },
  avatar: {
    bottom: 0,
    top: 45,
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
  },
  userNameAndEmailContainer: {
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "center",
  },
  userName: {
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    fontWeight: "700",
    textTransform: "uppercase",
  },
  userEmail: {
    paddingTop: 10,
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    fontWeight: "400",
    textTransform: "none",
  },
  editProfile: {
    paddingTop: 28,
    paddingLeft: 0,
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: editProfileColor,
    textDecorationLine: "underline",
  },
  clickToLogOut: {
    alignItems: "center",
    position: "relative",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: 80,
    width: "100%",
  },
  title: {
    left: 20,
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1.25,
    fontWeight: "400",
  },
  rateApp: {
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "flex-start",
    marginBottom: 40,
  },
  starDesign: {
    marginRight: 20,
  },
  loriiniTribes: {
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 40,
  },
  companySlogan: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: companySloganColor,
  },
});
